<template>
  <div class="page-liuxuan-test">
    <start-page @userName="handleShowQaPage"
                v-if="showStartPage"
    />
    <qa-page :name="name"
             v-if="showQaPage"
             @score="handleShowResultPage"
    />
    <result-page name="name"
                 :score="score"
                 v-if="showResultPage"
                 @preImg="handlePreImg"
    />
    <result-img :name="name"
                :number="number"
                :info="info"
                :info-random="infoRandom"
                @hideImg="handleHideImg"
                v-if="showResultImg"
    />
  </div>
</template>
<script>
  import StartPage from '@/pages/2019/LiuXuanTest/components/StartPage';
  import QaPage from '@/pages/2019/LiuXuanTest/components/QAPage';
  import ResultPage from '@/pages/2019/LiuXuanTest/components/ResultPage';
  import ResultImg from '@/pages/2019/LiuXuanTest/components/ResultImg';
  import { getStaticShareInfo } from '@/services/app';

  export default {
    name: 'LiuXuanTest2019',
    metaInfo: {
      title: '现代老母亲育儿鉴定指南',
    },
    components: {
      StartPage,
      QaPage,
      ResultPage,
      ResultImg,
    },
    data() {
      return {
        showStartPage: false,
        showQaPage: false,
        showResultPage: false,
        showResultImg: false,
        name: '',
        score: 0,
        info: null,
        infoRandom: 0,
        number: 0,
      };
    },
    methods: {
      async getStaticShareInfo() {
        await getStaticShareInfo('marketing.liuxuan_test_2019');
      },
      handleShowQaPage(name) {
        this.name = name;
        this.showStartPage = false;
        this.showQaPage = true;
      },
      handleShowResultPage(score) {
        this.score = score;
        this.showResultPage = true;
      },
      handlePreImg(data) {
        this.info = data.info;
        this.infoRandom = data.infoRandom;
        this.number = data.number;
        this.showQaPage = false;
        this.showResultPage = false;
        this.showResultImg = true;
      },
      handleHideImg() {
        this.showResultImg = false;
      },
    },
    created() {
      this.showStartPage = true;
      this.getStaticShareInfo();
      this.$store.dispatch('toggleShowHeader', false);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-liuxuan-test {
    box-sizing: border-box;
    background: @color-white;
    position: relative;
    z-index: @z-index-extra-extra-large;
  }
</style>
